var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasking3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1210_1036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1210_1036)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1210_1036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 91,
    width: 91,
    height: 91,
    transform: "rotate(-90 0 91)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1210_1036)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 49.238,
    y1: 137.429,
    x2: -46.4292,
    y2: 41.7618,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.7863,
    y1: 117.881,
    x2: -26.881,
    y2: 22.2137,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.0118,
    y1: 127.655,
    x2: -36.6555,
    y2: 31.9878,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.5606,
    y1: 108.106,
    x2: -17.1067,
    y2: 12.4392,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.1246,
    y1: 132.542,
    x2: -41.5426,
    y2: 36.8748,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.4154,
    y1: 116.252,
    x2: -25.2518,
    y2: 20.5845,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.8989,
    y1: 122.768,
    x2: -31.7684,
    y2: 27.1006,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.4477,
    y1: 103.22,
    x2: -12.2196,
    y2: 7.55229,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.8666,
    y1: 135.8,
    x2: -44.8006,
    y2: 40.1329,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.044,
    y1: 114.623,
    x2: -23.6232,
    y2: 18.9556,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.6412,
    y1: 126.026,
    x2: -35.0261,
    y2: 30.3587,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1891,
    y1: 106.478,
    x2: -15.4781,
    y2: 10.8103,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.754,
    y1: 130.913,
    x2: -39.9132,
    y2: 35.2459,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6734,
    y1: 112.994,
    x2: -21.9938,
    y2: 17.3265,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5283,
    y1: 121.139,
    x2: -30.139,
    y2: 25.4717,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.0763,
    y1: 101.59,
    x2: -10.591,
    y2: 5.92313,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.496,
    y1: 134.171,
    x2: -43.1712,
    y2: 38.5039,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.3026,
    y1: 111.365,
    x2: -20.3647,
    y2: 15.6973,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.2703,
    y1: 124.397,
    x2: -33.3969,
    y2: 28.7298,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.8186,
    y1: 104.848,
    x2: -13.8487,
    y2: 9.18119,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.3832,
    y1: 129.284,
    x2: -38.2841,
    y2: 33.6167,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.9314,
    y1: 109.736,
    x2: -18.7358,
    y2: 14.0684,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.1569,
    y1: 119.51,
    x2: -28.5104,
    y2: 23.8426,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.7057,
    y1: 99.9615,
    x2: -8.96157,
    y2: 4.29423,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.3348,
    y1: 98.3326,
    x2: -7.33243,
    y2: 2.66532,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.883,
    y1: 78.7842,
    x2: 12.2158,
    y2: -16.883,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.1088,
    y1: 88.5584,
    x2: 2.44154,
    y2: -7.10885,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.657,
    y1: 69.01,
    x2: 21.9901,
    y2: -26.6572,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2217,
    y1: 93.4456,
    x2: -2.44558,
    y2: -2.22164,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.512,
    y1: 77.1553,
    x2: 13.8449,
    y2: -18.5119,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.996,
    y1: 83.6714,
    x2: 7.32868,
    y2: -11.9958,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.545,
    y1: 64.1231,
    x2: 26.8775,
    y2: -31.5441,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.826,
    y1: 55.8421,
    x2: 35.1584,
    y2: -39.8252,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.9637,
    y1: 96.7037,
    x2: -5.70359,
    y2: 1.03642,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.141,
    y1: 75.5262,
    x2: 15.4738,
    y2: -20.1411,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.7379,
    y1: 86.9295,
    x2: 4.07069,
    y2: -8.73775,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.286,
    y1: 67.3809,
    x2: 23.6189,
    y2: -28.2863,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.567,
    y1: 59.0999,
    x2: 31.8999,
    y2: -36.5673,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.8508,
    y1: 91.8167,
    x2: -0.816447,
    y2: -3.85055,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.77,
    y1: 73.8973,
    x2: 17.103,
    y2: -21.77,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.625,
    y1: 82.0423,
    x2: 8.95781,
    y2: -13.625,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.173,
    y1: 62.4939,
    x2: 28.5061,
    y2: -33.1733,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.454,
    y1: 54.2129,
    x2: 36.787,
    y2: -41.4543,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.5928,
    y1: 95.0747,
    x2: -4.07444,
    y2: -0.59249,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.399,
    y1: 72.2681,
    x2: 18.7321,
    y2: -23.3991,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.367,
    y1: 85.3006,
    x2: 5.69983,
    y2: -10.3667,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.916,
    y1: 65.752,
    x2: 25.2484,
    y2: -29.9152,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.197,
    y1: 57.471,
    x2: 33.5293,
    y2: -38.1963,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.4799,
    y1: 90.1875,
    x2: 0.812696,
    y2: -5.4797,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.028,
    y1: 70.639,
    x2: 20.3609,
    y2: -25.0283,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.254,
    y1: 80.4134,
    x2: 10.5867,
    y2: -15.2539,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.803,
    y1: 60.865,
    x2: 30.1355,
    y2: -34.8022,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.084,
    y1: 52.584,
    x2: 38.4164,
    y2: -43.0832,
    stroke: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.63,
    y1: 51.0367,
    x2: 39.9629,
    y2: -44.6306,
    stroke: "#8F9DD2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 15C58 5.05888 66.0589 -3 76 -3C85.9411 -3 94 5.05887 94 15C94 24.9411 85.9411 33 76 33C66.0589 33 58 24.9411 58 15Z",
    stroke: "url(#paint0_linear_1210_1036)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-9 71C-9 57.1929 2.19288 46 16 46C29.8071 46 41 57.1929 41 71C41 84.8071 29.8071 96 16 96C2.19288 96 -9 84.8071 -9 71Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2 89.0001C70.9018 89.0001 70.6274 88.8097 70.5322 88.5101C70.4916 88.4191 70.248 88.2133 70.08 88.1139C67.994 86.8917 65.6364 81.4877 65.3746 80.8759L63.1612 72.3331C63.0828 72.0307 63.2144 71.7129 63.4832 71.5547C64.8482 70.7525 65.8996 70.8239 66.5464 71.0255C67.4522 71.3097 68.197 72.0293 68.6954 73.1073L69.8 75.4145V62.4001C69.8 60.8559 71.0558 59.6001 72.6 59.6001C74.1442 59.6001 75.4 60.8559 75.4 62.4001V69.7767C75.8116 69.5373 76.2904 69.4001 76.8 69.4001C77.8178 69.4001 78.7082 69.9447 79.1996 70.7581C79.6868 70.3479 80.3154 70.1001 81 70.1001C82.2194 70.1001 83.2596 70.8841 83.6432 71.9733C84.0884 71.6751 84.6246 71.5001 85.2 71.5001C86.7442 71.5001 88 72.7559 88 74.3001V85.5001C88 87.4293 86.4306 89.0001 84.5 89.0001H77.5C77.1136 89.0001 76.8 88.6865 76.8 88.3001C76.8 87.9137 77.1136 87.6001 77.5 87.6001H84.5C85.6578 87.6001 86.6 86.6579 86.6 85.5001V74.3001C86.6 73.5287 85.9728 72.9001 85.2 72.9001C84.4272 72.9001 83.8 73.5287 83.8 74.3001C83.8 74.6865 83.4864 75.0001 83.1 75.0001C82.7136 75.0001 82.4 74.6865 82.4 74.3001V72.9001C82.4 72.1287 81.7728 71.5001 81 71.5001C80.2272 71.5001 79.6 72.1287 79.6 72.9001C79.6 73.2865 79.2864 73.6001 78.9 73.6001C78.5136 73.6001 78.2 73.2865 78.2 72.9001V72.2001C78.2 71.4287 77.5728 70.8001 76.8 70.8001C76.0272 70.8001 75.4 71.4287 75.4 72.2001C75.4 72.5865 75.0864 72.9001 74.7 72.9001C74.3136 72.9001 74 72.5865 74 72.2001V62.4001C74 61.6287 73.3728 61.0001 72.6 61.0001C71.8272 61.0001 71.2 61.6287 71.2 62.4001V78.5001C71.2 78.8263 70.9732 79.1105 70.654 79.1833C70.332 79.2589 70.01 79.0965 69.8672 78.8025L67.4284 73.7023C67.196 73.1997 66.7844 72.5655 66.1278 72.3611C65.6994 72.2281 65.2066 72.2813 64.655 72.5235L66.6948 80.4265C67.322 81.8727 69.3534 86.0685 70.7884 86.9085C70.9928 87.0289 71.669 87.4671 71.8664 88.0915C71.9826 88.4597 71.7782 88.8531 71.41 88.9693C71.3414 88.9903 71.27 89.0001 71.2 89.0001Z",
    fill: "#E9385F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 57.5001C71.7208 57.5001 71.5416 57.4315 71.4044 57.2957L67.9044 53.7957C67.6314 53.5227 67.6314 53.0789 67.9044 52.8059C68.1774 52.5329 68.6212 52.5329 68.8942 52.8059L71.9 55.8103L79.8044 47.9059C80.0774 47.6329 80.5212 47.6329 80.7942 47.9059C81.0672 48.1789 81.0672 48.6227 80.7942 48.8957L72.3942 57.2957C72.2584 57.4315 72.0792 57.5001 71.9 57.5001Z",
    fill: "#E9385F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 62.4H48.1C46.9422 62.4 46 61.4578 46 60.3V49.1C46 47.9422 46.9422 47 48.1 47H59.3C60.4578 47 61.4 47.9422 61.4 49.1V60.3C61.4 61.4578 60.4578 62.4 59.3 62.4ZM48.1 48.4C47.715 48.4 47.4 48.7136 47.4 49.1V60.3C47.4 60.6864 47.715 61 48.1 61H59.3C59.685 61 60 60.6864 60 60.3V49.1C60 48.7136 59.685 48.4 59.3 48.4H48.1Z",
    fill: "#E9385F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 80.6002H48.1C46.9422 80.6002 46 79.658 46 78.5002V67.3002C46 66.1424 46.9422 65.2002 48.1 65.2002H59.3C60.4578 65.2002 61.4 66.1424 61.4 67.3002V78.5002C61.4 79.658 60.4578 80.6002 59.3 80.6002ZM48.1 66.6002C47.715 66.6002 47.4 66.9138 47.4 67.3002V78.5002C47.4 78.8866 47.715 79.2002 48.1 79.2002H59.3C59.685 79.2002 60 78.8866 60 78.5002V67.3002C60 66.9138 59.685 66.6002 59.3 66.6002H48.1Z",
    fill: "#E9385F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7 62.4H66.3C65.1422 62.4 64.2 61.4578 64.2 60.3V49.1C64.2 47.9422 65.1422 47 66.3 47H77.5C77.8864 47 78.2 47.3136 78.2 47.7C78.2 48.0864 77.8864 48.4 77.5 48.4H66.3C65.915 48.4 65.6 48.7136 65.6 49.1V60.3C65.6 60.6864 65.915 61 66.3 61H67.7C68.0864 61 68.4 61.3136 68.4 61.7C68.4 62.0864 68.0864 62.4 67.7 62.4Z",
    fill: "#E9385F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 62.4001H74.7C74.3136 62.4001 74 62.0865 74 61.7001C74 61.3137 74.3136 61.0001 74.7 61.0001H77.5C77.885 61.0001 78.2 60.6865 78.2 60.3001V53.3001C78.2 52.9137 78.5136 52.6001 78.9 52.6001C79.2864 52.6001 79.6 52.9137 79.6 53.3001V60.3001C79.6 61.4579 78.6578 62.4001 77.5 62.4001Z",
    fill: "#E9385F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3043 6.54348H35.6739C35.6732 5.86913 35.405 5.22262 34.9281 4.74579C34.4513 4.26895 33.8048 4.00074 33.1304 4H31.4348C30.7604 4.00074 30.1139 4.26895 29.6371 4.74579C29.1603 5.22262 28.892 5.86913 28.8913 6.54348H7.69565C7.2461 6.54399 6.8151 6.72281 6.49722 7.04069C6.17933 7.35858 6.00052 7.78957 6 8.23913V9.93478C6.00052 10.3843 6.17933 10.8153 6.49722 11.1332C6.8151 11.4511 7.2461 11.6299 7.69565 11.6304H28.8913C28.892 12.3048 29.1603 12.9513 29.6371 13.4281C30.1139 13.905 30.7604 14.1732 31.4348 14.1739H33.1304C33.8048 14.1732 34.4513 13.905 34.9281 13.4281C35.405 12.9513 35.6732 12.3048 35.6739 11.6304H43.3043C43.7539 11.6299 44.1849 11.4511 44.5028 11.1332C44.8207 10.8153 44.9995 10.3843 45 9.93478V8.23913C44.9995 7.78957 44.8207 7.35858 44.5028 7.04069C44.1849 6.72281 43.7539 6.54399 43.3043 6.54348ZM7.69565 9.93478V8.23913H28.8913V9.93478H7.69565ZM33.9783 11.6304C33.978 11.8552 33.8886 12.0707 33.7297 12.2297C33.5707 12.3886 33.3552 12.478 33.1304 12.4783H31.4348C31.21 12.478 30.9945 12.3886 30.8355 12.2297C30.6766 12.0707 30.5872 11.8552 30.587 11.6304V6.54348C30.5872 6.31869 30.6766 6.10317 30.8355 5.94422C30.9945 5.78527 31.21 5.69588 31.4348 5.69565H33.1304C33.3552 5.69588 33.5707 5.78527 33.7297 5.94422C33.8886 6.10317 33.978 6.31869 33.9783 6.54348V11.6304ZM43.3043 9.93478H35.6739V8.23913H43.3043V9.93478ZM43.3043 20.9565H22.1087C22.108 20.2822 21.8397 19.6357 21.3629 19.1588C20.8861 18.682 20.2396 18.4138 19.5652 18.413H17.8696C17.1952 18.4138 16.5487 18.682 16.0719 19.1588C15.595 19.6357 15.3268 20.2822 15.3261 20.9565H7.69565C7.2461 20.957 6.8151 21.1359 6.49722 21.4537C6.17933 21.7716 6.00052 22.2026 6 22.6522V24.3478C6.00052 24.7974 6.17933 25.2284 6.49722 25.5463C6.8151 25.8641 7.2461 26.043 7.69565 26.0435H15.3261C15.3268 26.7178 15.595 27.3643 16.0719 27.8412C16.5487 28.318 17.1952 28.5862 17.8696 28.587H19.5652C20.2396 28.5862 20.8861 28.318 21.3629 27.8412C21.8397 27.3643 22.108 26.7178 22.1087 26.0435H43.3043C43.7539 26.043 44.1849 25.8641 44.5028 25.5463C44.8207 25.2284 44.9995 24.7974 45 24.3478V22.6522C44.9995 22.2026 44.8207 21.7716 44.5028 21.4537C44.1849 21.1359 43.7539 20.957 43.3043 20.9565ZM7.69565 24.3478V22.6522H15.3261V24.3478H7.69565ZM20.413 26.0435C20.4128 26.2683 20.3234 26.4838 20.1645 26.6427C20.0055 26.8017 19.79 26.8911 19.5652 26.8913H17.8696C17.6448 26.8911 17.4293 26.8017 17.2703 26.6427C17.1114 26.4838 17.022 26.2683 17.0217 26.0435V20.9565C17.022 20.7317 17.1114 20.5162 17.2703 20.3573C17.4293 20.1983 17.6448 20.1089 17.8696 20.1087H19.5652C19.79 20.1089 20.0055 20.1983 20.1645 20.3573C20.3234 20.5162 20.4128 20.7317 20.413 20.9565V26.0435ZM43.3043 24.3478H22.1087V22.6522H43.3043V24.3478ZM43.3043 35.3696H31.4348C31.434 34.6952 31.1658 34.0487 30.689 33.5719C30.2122 33.095 29.5656 32.8268 28.8913 32.8261H27.1957C26.5213 32.8268 25.8748 33.095 25.398 33.5719C24.9211 34.0487 24.6529 34.6952 24.6522 35.3696H7.69565C7.2461 35.3701 6.8151 35.5489 6.49722 35.8668C6.17933 36.1847 6.00052 36.6157 6 37.0652V38.7609C6.00052 39.2104 6.17933 39.6414 6.49722 39.9593C6.8151 40.2772 7.2461 40.456 7.69565 40.4565H24.6522C24.6529 41.1309 24.9211 41.7774 25.398 42.2542C25.8748 42.731 26.5213 42.9993 27.1957 43H28.8913C29.5656 42.9993 30.2122 42.731 30.689 42.2542C31.1658 41.7774 31.434 41.1309 31.4348 40.4565H43.3043C43.7539 40.456 44.1849 40.2772 44.5028 39.9593C44.8207 39.6414 44.9995 39.2104 45 38.7609V37.0652C44.9995 36.6157 44.8207 36.1847 44.5028 35.8668C44.1849 35.5489 43.7539 35.3701 43.3043 35.3696ZM7.69565 38.7609V37.0652H24.6522V38.7609H7.69565ZM29.7391 40.4565C29.7389 40.6813 29.6495 40.8968 29.4906 41.0558C29.3316 41.2147 29.1161 41.3041 28.8913 41.3043H27.1957C26.9709 41.3041 26.7553 41.2147 26.5964 41.0558C26.4374 40.8968 26.348 40.6813 26.3478 40.4565V35.3696C26.348 35.1448 26.4374 34.9293 26.5964 34.7703C26.7553 34.6114 26.9709 34.522 27.1957 34.5217H28.8913C29.1161 34.522 29.3316 34.6114 29.4906 34.7703C29.6495 34.9293 29.7389 35.1448 29.7391 35.3696V40.4565ZM43.3043 38.7609H31.4348V37.0652H43.3043V38.7609Z",
    fill: "#2337B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1210_1036",
    x1: 76,
    y1: 34,
    x2: 76,
    y2: -4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAF45",
    stopOpacity: 0.22
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasking3);
export default __webpack_public_path__ + "static/media/masking-3.84dafe29a692acadc237d86d2171444e.svg";
export { ForwardRef as ReactComponent };